import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

const formatter = Intl.NumberFormat('en-US', {
	currency: 'USD',
	style: 'currency'
});

type Size = 'medium' | 'large' | 'xlarge';

export const formatCurrency = (amount: number) => formatter.format(amount);

export const replaceImageUrl = (src?: string | null, size: Size = 'large') => {
	const regex = new RegExp(`https:\/\/assets\.mvmnt\.io\/(?=.*\.(?!svg)[^"]+)`, 'g');
	return src?.replaceAll(regex, `https://assets.mvmnt.io/${size}_`);
};

export const replaceImg = (html?: string | null, size: Size = 'large') => {
	return replaceImageUrl(html, size)?.replaceAll('<img', '<image-element');
};

export const sizeUpImg = (src: string) => {
	return src
		.replace('https://assets.mvmnt.io/medium', 'https://assets.mvmnt.io/')
		.replace('https://assets.mvmnt.io/large_', 'https://assets.mvmnt.io/')
		.replace('https://assets.mvmnt.io/xlarge_', 'https://assets.mvmnt.io/');
};

export const setSizeImg = (src: string, size: Size) => {
	return replaceImageUrl(sizeUpImg(src), size);
};
